import React, { useEffect, useState } from "react";
import { Card, Form, Spinner } from "react-bootstrap";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { isHTMLIdentifier } from "../../../../utils/universalFunction";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";

const AssignGender = ({
  schemaId,
  studyId,
  derivationData,
  getAssignedGenderinSchema,
}) => {
  const [eventList, setEventList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [formFieldList, setFormFieldList] = useState([]);
  const [assignedEventId, setAssignedEventId] = useState("");
  const [assignedTimepointId, setAssignedTimepointId] = useState("");
  const [assignedFormId, setAssignedFormId] = useState("");
  const [assignedFormVersion, setAssignedFormVersion] = useState("");
  const [assignedFieldId, setAssignedFieldId] = useState("");
  const [eventLoader, setEventLoader] = useState(false);
  const [formLoader, setFormLoader] = useState(false);
  const [fieldLoader, setFieldLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getEventBasedonSchema = async () => {
    setEventLoader(true);
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(
      studyId,
      schemaId,
      "all"
    );
    setEventList(data?.data || []);
    setEventLoader(false);
  };

  const getSchemaEventForms = async () => {
    setFormLoader(true);
    let data =
      await studyEventManagementServices.getSchemaEventForms(
        studyId,
        schemaId,
        assignedEventId,
        assignedTimepointId || "no", StudyMode
      );
    setFormList(data?.data || []);
    setFormLoader(false);
  };

  const getStudyLevelFormFieldsByVersion = async () => {
    setFieldLoader(true);
    let data =
      await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
        studyId,
        assignedFormId,
        assignedFormVersion
      );
    if (data === "AbortError") {
      setFieldLoader(true);
    } else {
      setFormFieldList(data?.data?.formFields || []);
      setFieldLoader(false);
    }
  };

  const assignGenderinSchema = async () => {
    setButtonLoader(true)
    let userData = {};
    userData.studyId = studyId;
    userData.schemaId = schemaId;
    userData.derivation = {
      eventId: assignedEventId,
      timePointUniqueId: assignedTimepointId || "",
      formId: assignedFormId,
      formVersion: assignedFormVersion,
      fieldId: assignedFieldId,
    };
    let data = await studyEventFormSchemaServices.assignGenderinSchema(
      userData
    );
    if (data?.statusCode === 200) {
      getAssignedGenderinSchema();
    }
    setButtonLoader(false)
  };

  useEffect(() => {
    if (assignedFormId && assignedFormVersion && studyId) {
      getStudyLevelFormFieldsByVersion();
    }
  }, [assignedFormId, assignedFormVersion, studyId]);

  useEffect(() => {
    if (schemaId && studyId && assignedEventId) {
      getSchemaEventForms();
    }
  }, [schemaId, studyId, assignedEventId]);

  useEffect(() => {
    if (schemaId && studyId) {
      getEventBasedonSchema();
    }
  }, [schemaId, studyId]);

  useEffect(() => {
    setAssignedEventId(derivationData?.derivation?.eventId || "");
    setAssignedTimepointId(derivationData?.derivation?.timePointUniqueId || "");
    setAssignedFormId(derivationData?.derivation?.formId || "");
    setAssignedFormVersion(derivationData?.derivation?.formVersion || "");
    setAssignedFieldId(derivationData?.derivation?.fieldId || "");
  }, [derivationData]);
  return (
    <div className="w-50 m-auto mt-3">
      <Card className="app-card mb-3 bg-light border">
        {eventLoader || formLoader || fieldLoader ? (
          <div
            className="hstack justify-content-center"
            style={{ height: "275px" }}
          >
            <PageLoader />
          </div>
        ) : (
          <Card.Body>
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Events{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Select
                className="br3"
                style={{ fontSize: 12 }}
                onChange={(e) => {
                  setAssignedEventId(e.target.value);
                  setAssignedTimepointId(e.target[e.target.selectedIndex].id);
                }}
                required
              >
                <option value="" id="">
                  Select Event
                </option>
                {eventList?.map((item, index) => (
                  <option
                    key={index}
                    selected={
                      `${item.eventId}${item?.row?.["TIMEPOINTUNIQUEID"] || ""
                      }` === `${assignedEventId}${assignedTimepointId || ""}`
                    }
                    value={item?.eventId}
                    id={item?.row?.["TIMEPOINTUNIQUEID"] || ""}
                  >
                    {item?.row?.["EVENTID"]} {item?.row?.["TIMEPOINTUNIQUEID"] && `(${item?.row?.["TIMEPOINTID"]})`}
                  </option>
                ))}
                <option selected={assignedEventId === "specialForm"} value="specialForm" id="">Special Form</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-1">
              <Form.Group className="mb-1">
                <Form.Label className="mb-1 fw-bold">
                  Forms{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  className="br3"
                  style={{ fontSize: 12 }}
                  onChange={(e) => {
                    setAssignedFormId(e.target.value);
                    setAssignedFormVersion(e.target[e.target.selectedIndex].id);
                  }}
                  required
                >
                  <option value="" id="">
                    Select Form
                  </option>
                  {formList?.map((item, index) => (
                    <option
                      selected={item?.formId === assignedFormId}
                      key={index}
                      value={item?.formId}
                      id={item.version}
                    >
                      {item.formLabel}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="mb-1 fw-bold">
                  Fields{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  onChange={(e) => setAssignedFieldId(e.target.value)}
                  className="br3"
                  style={{ fontSize: 12 }}
                  required
                >
                  <option value="">Select Field</option>
                  {formFieldList?.map((item, index) => (
                    <option
                      selected={item?.id === Number(assignedFieldId)}
                      key={index}
                      value={item?.id}
                    >
                      {isHTMLIdentifier(item?.fieldLabel || "") ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item?.fieldLabel,
                          }}
                        />
                      ) : (
                        item?.fieldLabel
                      )}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form.Group>
            <div className="text-end w-100 border-light pt-2">
              <button
                onClick={assignGenderinSchema}
                disabled={
                  !assignedEventId ||
                  !assignedFormId ||
                  !assignedFormVersion ||
                  !assignedFieldId ||
                  !schemaId ||
                  buttonLoader
                }
                className="updateProfile"
              >
                {buttonLoader ? (
                  <div className="hstack gap-2">
                    <Spinner size="sm" /> Assiging...
                  </div>
                ) : (
                  "Assign Now"
                )}
              </button>
            </div>
          </Card.Body>
        )}
      </Card>
    </div>
  );
};

export default AssignGender;
